import script from "./RefusalListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RefusalListView.vue?vue&type=script&lang=ts&setup=true"

import "./RefusalListView.vue?vue&type=style&index=0&id=2dfc8096&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfc8096"]])

export default __exports__